import React, { useLayoutEffect } from 'react';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { CITY_PATH, NEW_CITY_PATH } from '../../../../config/paths';
import { CITIES_COLUMNS } from '../../../../config/columns';
import ModuleList from '../../../layout/ModuleList';
import { clearCities, getCities } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


const Cities = ({
  breadcrumbs,
  cities,
  loading,
  dispatchGetCities,
  dispatchClearCities,
}) => {
  useLayoutEffect(() => () => dispatchClearCities(), []);
  const data = cities.get('content') || [];
  const pages = cities.get('totalPages') || null;
  const defaultPageSize = cities.get('size') || DEFAULT_PAGE_SIZE;
  
  return (
    <ModuleList
      title="Ciudades"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_CITY_PATH}
      tableStructure={{
        columns: CITIES_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetCities,
        modelPath: CITY_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
}


const mapDispatchToProps = { 
  dispatchGetCities: getCities,
  dispatchClearCities: clearCities,
};

const mapStateToProps = ({ LocationUnit }) => ({
  breadcrumbs: [
    ...LocationUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ciudades',

      href: CITY_PATH,
    },
  ],
  cities: LocationUnit.City.getIn(['all', 'content']),
  loading: LocationUnit.City.getIn(['all', 'loading']),
});

Cities.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cities: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetCities: PropTypes.func.isRequired,
  dispatchClearCities: PropTypes.func.isRequired,
};

Cities.defaultProps = {
  cities: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Cities);